import Router from 'next/router'
import React from 'react'
import { firebase } from '../firebase'
import { log } from 'log'
import { trpc } from 'utils/trpc'

export const useRedirectResult = () => {
  const utils = trpc.useContext()
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(false)
  const [success, setSuccess] = React.useState<boolean>()

  React.useEffect(() => {
    ;(async () => {
      try {
        setLoading(true)
        const result = await firebase.auth().getRedirectResult()
        const idToken = await result.user?.getIdToken()

        if (idToken) {
          const data = await utils.me.googleLogin.fetch({ idToken })

          window.localStorage.setItem('token', data.token)
          const pageId = data.activePageId

          if (pageId) {
            await Router.push(`/page/${pageId}`)
          } else {
            log.error('no page id found for user')
          }

          setSuccess(true)
        }
      } catch (e) {
        setError(true)
        setSuccess(false)
        console.log(e)
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  return {
    loading,
    error,
    success,
  }
}
